<template>
  <v-dialog v-model="dialog" content-class="detail-dialog" @click:outside="close" @keydown.esc="close">
    <v-toolbar>
      <v-toolbar-title>
        {{ fields[2].value }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="close"><v-icon>clear</v-icon></v-btn>
    </v-toolbar>
    <v-snackbar v-model="snackbar.model" top :color="snackbar.color">
      {{ snackbar.detail }}
    </v-snackbar>
    <SignatureDialog2 ref="signaturePad" no-tc @signed-and-submit="submit" />
    <v-card flat class="detail-dialog-card">
      <v-tabs v-model="tabs">
        <v-tab>Entity Info</v-tab>
        <v-tab @click="loadBankAccounts">Bank account</v-tab>
        <v-tab @click="loadChecklists" v-show="false">Checklist</v-tab>
        <v-tab @click="loadDocuments">Documents</v-tab>
        <v-tab-item>
          <v-card flat>
            <v-toolbar dense flat>
              <v-toolbar-items>
                <template>
                  <v-btn text :disabled="!changed" @click="save">
                    <v-icon left>done</v-icon> Save
                  </v-btn>
                  <v-btn text :disabled="!changed" @click="cancel">
                    Cancel
                  </v-btn>
                  <!--
                  <v-btn text disabled v-if="signature">
                    <v-chip color="success">Signed</v-chip>
                  </v-btn>
                  <v-btn outlined color="primary" v-else @click="signAndSubmit">
                    <v-icon left>gesture</v-icon> Sign and submit
                  </v-btn>
                  -->
                </template>
              </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
              <v-form v-model="valid">
                <v-container class="pt-2">
                  <EditForm :items="fields" v-if="loaded" @data-changed="changed = true" ref="editForm"/>
                </v-container>
              </v-form>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <BankAccount :entity-id="itemId" ref="bankAccount"></BankAccount>
        </v-tab-item>
        <v-tab-item v-show="false">
          <ChecklistList :item-id="itemId" ref="checklistManager"
            @update-checklist-error="showChecklistError" />
        </v-tab-item>
        <v-tab-item style="height:100%">
          <DocumentManager :item-id="itemId" ref="docManager"/>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </v-dialog>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import { Getter, namespace } from 'vuex-class'
import EditForm from '@/components/public/EditForm'
import BankAccount from '@/components/bankaccount'
import DocumentManager from '@/components/entity/DocumentManager'
import SignatureDialog2 from '@/components/dialog/SignatureDialog2'
import ChecklistList from '@/components/entity/ChecklistList'

const EntityModule = namespace('entity')

@Component({
  components: {
    EditForm,
    BankAccount,
    DocumentManager,
    SignatureDialog2,
    ChecklistList
  }
})
export default class EntityDetail extends Vue {
  dialog = false
  valid = false
  tabs = 0
  submitted = false
  loaded = false
  signature = false
  signaturePic = false
  loading = false
  changed = false
  snackbar = { model: false }
  itemId = null

  @Getter rules
  @EntityModule.Getter fields
  // @EntityModule.Mutation updateFieldItem
  @EntityModule.Action setFieldItems
  @EntityModule.Action updateFromAPI

  load (item) {
    this.itemId = item.id
    this.loaded = false
    this.fields[3].disabled = false
    this.updateFromAPI(item.id)
      .then(resp => {
        this.loaded = true
        this.tabs = 0
        this.signature = this.fields[1].value
        if (this.signature) {
          this.fields[3].disabled = true
        }
        this.dialog = true
      })
    /*
    for (let k of Object.keys(item)) {
      this.updateFieldItem({ name: k, value: item[k] })
    }
    */
    // this.$nextTick(() => { this.loaded = true })
  }

  close () {
    this.$emit('update-detail')
    this.dialog = false
  }

  showChecklistError (data) {
    this.snackbar = data
  }

  updateItem (item) {
    item._loading = true
    this.setFieldItem(item)
      .catch(err => {
        const resp = err.response
        this.snackbar = {
          model: true,
          detail: `Not able to update entity: ${resp.data.detail}`,
          color: 'error'
        }
        // TODO restore old value in profileItems
      })
      .finally(() => {
        item._loading = false
        this.$emit('update-detail')
      })
  }

  signAndSubmit () {
    this.$refs.signaturePad.open()
  }

  submit (data) {
    this.setFieldItems({
      id: this.fields[0].value,
      items: [{
        name: 'signature',
        value: data
      }]
    })
      .then(resp => {
        this.snackbar = {
          model: true,
          detail: 'Submit sucessfullty, please waiting for apprival.',
          color: 'success'
        }
        this.$emit('entity-updated')
      })
      .catch(err => {
        const message = err.response.data.detail
        this.snackbar = {
          model: true,
          detail: `Submit failed, ${message}`,
          color: 'error'
        }
      })
      .finally(() => {
        this.$refs.signaturePad.close()
      })
  }

  save () {
    this.loading = true
    const data = this.$refs.editForm.save()

    this.setFieldItems(data)
      .then(resp => {
        this.snackbar = {
          model: true,
          detail: 'Saved!',
          color: 'success'
        }
        this.changed = false
      })
      .catch(err => {
        const resp = err.response
        this.snackbar = {
          model: true,
          detail: `Not able to update profile: ${resp.data.detail}`,
          color: 'error'
        }
      })
      .finally(() => {
        this.loading = false
      })
  }

  cancel () {
    this.$refs.editForm.cancel()
    this.changed = false
  }

  loadBankAccounts () {
    const delay = this.$refs.bankAccount ? 0 : 100
    setTimeout(() => {
      this.$refs.bankAccount.load(this.itemId)
    }, delay)
  }

  loadChecklists () {
    const delay = this.$refs.checklistManager ? 0 : 100
    setTimeout(() => {
      this.$refs.checklistManager.load()
    }, delay)
  }

  loadDocuments () {
    const delay = this.$refs.docManager ? 0 : 100
    setTimeout(() => {
      this.$refs.docManager.load(this.itemId)
    }, delay)
  }
}
</script>

<style scoped>
.detail-dialog {
  position: fixed;
  margin: 0;
  width: auto;
  top: 0; left: 50%; bottom: 0; right: 0;
  max-height: 100% !important;
  @media screen and (max-width: 960px) {
    left: 30%;
  }
  @media screen and (max-width: 600px) {
    left: 10%;
  }
}
.detail-dialog-card {
  border-radius: 0 !important;
  position: absolute;
  top: 64px; bottom: 0;
  left: 0; right: 0;
  @media screen and (max-width: 960px) {
    top: 56px;
  }
}
</style>
